import { configureStore, createSlice } from '@reduxjs/toolkit'
import { toolbarReducer } from 'redux/toolbar';
import { autocompleteReducer } from 'redux/autocomplete';
import { editorReducer } from 'redux/editor';
import { modalReducer } from 'redux/modal';

const reducer = {
  appInfo: createSlice({
    name: 'toolbar',
    initialState: {
      version: process.env.REACT_APP_VERSION
    }
  }).reducer,
  toolbar: toolbarReducer,
  autocomplete: autocompleteReducer,
  editor: editorReducer,
  modal: modalReducer,
};

const store = configureStore({ reducer });

export default store;

export const setupStore = (preloadedState) => {
  return configureStore({ reducer, preloadedState })
}